export default __webpack_public_path__ + "resources/icons/n312-6dfb.png";